import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "asset-task-detail" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提醒未确认员工 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex d-flex-row-reverse" }

import {onBeforeMount, reactive, ref, watch} from "vue";
import Api from "@/http/modules";
import tbMix from "@/global_mixin/tableMixin";
import {ElMessage, ElMessageBox} from "element-plus";
import {formatFullTime} from '@/utils/index'


export default /*#__PURE__*/_defineComponent({
  props: {
    task: null,
    show: { type: Boolean }
  },
  emits: ["back"],
  setup(__props: any, { emit }) {

const props = __props as {
  task: any,
  show: boolean
}


const {
  //创建
  "POST/office/asset/task/assets": taskAssetApi,
  "POST/office/asset/task/notify_unconfirmed_user": notifyUserApi,
  'GET/upload/preview': previewPicApi,
} = Api
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(taskAssetApi)
const params = reactive<{
  type: string
}>({
  type: "未确认"
})

const returnListPage = () => {
  emit("back")
}
const onTypeChange=(value:string)=>{
  params.type=value

  search()
}
const search = () => {
  page.value = 1;
  let type;
  if(params.type.indexOf("未确认")>=0){
    type="未确认"
  } else if(params.type.indexOf("已确认")>=0){
    type="已确认"
  }else{
    type="拍照资产"
  }
  var res = fetchData({
    no: props.task.no,
    type: type
  }).then(r=>{
    taskCount.confirmed="已确认（"+r.confirmedCount+"）"
    taskCount.unconfirmed="未确认（"+r.unConfirmedCount+"）"
    taskCount.pic="拍照资产（"+r.highlightCount+"）"
    if(params.type.indexOf("未确认")>=0){
      params.type = taskCount.unconfirmed
    } else if(params.type.indexOf("已确认")>=0){
      params.type = taskCount.confirmed
    }else{
      params.type = taskCount.pic
    }
  })
  console.log("res",res)
}
const taskCount = reactive({
  confirmed: "已确认",
  unconfirmed: "未确认",
  pic: "拍照资产",
})
watch(() => props.show, (cur, old) => {
  // console.log("show ",cur)
  if (cur) {
    params.type = "未确认"
    // console.log("watch show",taskCount)
    search()
  }
})

const notifyUser = () => {
  ElMessageBox.confirm("是否要再次发送企微提醒员工进行资产确认",
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
    return notifyUserApi()
  }).then(() => {
    ElMessage.success('成功')
  }).finally(() => {
  })

}
const rowClass = (data: { row: any, rowIndex: number, }) => {
  if (needHighlight(data.row)) {
    return "bg-highlight"
  } else {
    return "no-bg-highlight"
  }
}
const needHighlight = (row: any) => {
  // return row.purchasingPrice > row.categoryLimitPrice
  return parseFloat(row.purchasingPrice.replace(",","")) > parseFloat(row.categoryLimitPrice.replace(",",""))
}
const isShowPreview = ref<boolean>(false)
const previewUrl = ref<string>('')
const preview = (row: any) => {
  previewPicApi({fileId: row.confirmPic}).then((url: any) => {
    previewUrl.value = url
    isShowPreview.value = true
  })
}




return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_button, {
        type: "info",
        onClick: returnListPage
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: notifyUser,
        disabled: !__props.task||__props.task.status!=='PROCESSING'
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_el_radio_group, {
      modelValue: _unref(params).type,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(params).type) = $event)),
      class: "mt-20 mb-20",
      onChange: onTypeChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_button, {
          label: _unref(taskCount).confirmed,
          value: "已确认"
        }, null, 8, ["label"]),
        _createVNode(_component_el_radio_button, {
          label: _unref(taskCount).unconfirmed,
          value: "未确认"
        }, null, 8, ["label"]),
        _createVNode(_component_el_radio_button, {
          label: _unref(taskCount).pic,
          value: "拍照资产"
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", null, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "assetInventoryTbEle",
        border: "",
        class: "mt-15 asset-task-detail-tab",
        data: _unref(MI_tableData),
        "row-key": "id",
        "max-height": _unref(MI_height) - 100 + 'px',
        "row-class-name": rowClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "盘点状态",
            prop: "confirmStatusDesc",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点图片",
            "min-width": "100"
          }, {
            default: _withCtx(({row}) => [
              (row.confirmPic)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    onClick: ($event: any) => (preview(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "提交时间",
            prop: "confirmTime",
            "min-width": "180",
            formatter: _unref(formatFullTime)
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            label: "提交人",
            prop: "confirmUserName",
            "min-width": "200",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "所属团队",
            prop: "orgName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "所属公司",
            prop: "companyName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "固定资产编号",
            prop: "no",
            "min-width": "210",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "资产名称",
            prop: "name",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "规格型号",
            prop: "spec",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "电脑设备ID",
            prop: "deviceId",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "unit",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "数量",
            prop: "count",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "领用日期",
            prop: "ownerDate",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "领用人",
            prop: "ownerName",
            "min-width": "200",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "资产变动单号",
            prop: "lastAssetChangeNo",
            "min-width": "220",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "使用状态",
            prop: "statusDesc",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "存放位置",
            prop: "place",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "管理员",
            prop: "managerName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["data", "max-height"])), [
        [_directive_loading, _unref(MI_identify)]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_pagination, {
          disabled: _unref(MI_identify),
          background: "",
          small: "",
          total: _unref(MI_total),
          currentPage: _unref(page),
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
          "page-size": _unref(size),
          "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
          class: "mt-10",
          "page-sizes": [10, 30, 50, 100, 300, 1000],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(MI_pageChange),
          onSizeChange: _unref(MI_sizeChange)
        }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "预览(点击图片放大)",
      modelValue: isShowPreview.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isShowPreview).value = $event)),
      "append-to-body": "",
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        (isShowPreview.value)
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              style: {"width":"100%","max-height":"430px","overflow":"scroll"},
              src: previewUrl.value,
              fit: "cover",
              "close-on-press-escape": true,
              "preview-src-list": [previewUrl.value]
            }, null, 8, ["src", "preview-src-list"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})